import formName from 'constants/formName'
import { actions, actionTypes, selectors } from 'data'
import { SubmitTwoFactorActionType } from 'data/actions'
import { notifyError } from 'data/App/sagas'
import { TwoFactorFormType, TwoFAType } from 'data/types'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { twoFactorStatus } from 'services/api/user'
import { Response } from 'utils/fetchApi'

import disableTotpStep from './disableTotpStep'
import displayCodesStep from './displayCodesStep'
import enableSuccessStep from './enableSuccessStep'
import enableTotpStep from './enableTotpStep'
import generateNewCodesStep from './generateNewCodesStep'
import methodStep from './methodStep'
import setupStep from './setupStep'
import turnOffStep from './turnOffStep'
import verifyPasswordStep from './verifyPasswordStep'
import verifyTwoFactorStep from './verifyTwoFactorStep'

const steps = {
  disabletotp: disableTotpStep,
  displaycodes: displayCodesStep,
  enablesuccess: enableSuccessStep,
  enabletotp: enableTotpStep,
  generatenewcodes: generateNewCodesStep,
  method: methodStep,
  setup: setupStep,
  turnoff: turnOffStep,
  verifypassword: verifyPasswordStep,
  verifytwofactor: verifyTwoFactorStep
}

const getStatus = function* () {
  const data: Response<{
    readonly twoFactors: Array<TwoFAType>
  }> = yield call(twoFactorStatus)

  if (!data.ok) {
    yield call(notifyError, data.error.cause, 'KO_GENERIC')
    return
  }

  yield put(actions.auth.setTwoFactorStatus(data.response.twoFactors))
}

const submit = function* (action: SubmitTwoFactorActionType) {
  const form: TwoFactorFormType = yield select(selectors.twoFactor.getValues)

  yield put(actions.form.change(formName.TWO_FACTOR, 'loading', true))

  yield call(steps[action.payload.step], form)
}

export default function* twoFactorForm() {
  yield takeEvery(actionTypes.twoFactor.SUBMIT, submit)
  yield takeEvery(actionTypes.twoFactor.GET_STATUS, getStatus)
}
